export const SENSITIVITY_THRESHOLD = Object.freeze({
  LOW: 'Allows maximum conversational variation and engagement, but increases the risk of false negatives (missing explicit or problematic content).',
  MEDIUM:
    'Uses the recommended threshold to balance conversational flow with necessary controls.',
  HIGH: 'Provides maximum safety and compliance, but increases the risk of false positives (blocking relevant or benign queries).',
})

export const SENSITIVITY_LABELS = {
  LOW: 'Low',
  MEDIUM: 'Medium',
  HIGH: 'High',
}
